import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppRouter } from "./router";

// Initialize PDF.js worker before react-pdf can override it
import "./lib/pdfWorkerSetup";
// Initialize Sentry
import "./sentry";

// The app-shell service worker is registered via the useRegisterSW hook in
// ReloadPrompt.tsx (injectRegister: false). This lets us show a user-visible
// update notification instead of silently reloading. The capacitor build ships
// no service worker (Capgo owns the asset layer). See vite.config.ts.

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
);
